
export function stopPropagation(e){
	if (e && typeof e.stopPropagation === 'function'){
		e.stopPropagation();
		return true;
	}
	return false;
}